<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

	<div class="panel panel-orange notif-meteo"
		*ngFor="let notification of sortedMetasNotifications; trackBy: trackByParc">

		<div class="panel-heading">
			<h2>Dégradation des conditions météorologiques</h2>
		</div>

		<div class="panel-body">
			<p class="notif-meteo-texte">
				Les conditions météorologiques se dégradent sur le parc
				<strong>{{ notification.parcNom }} ({{ notification.parcCode }})</strong>.
			</p>

			<ul class="notif-meteo-indicateurs">
				<li *ngFor="let ind of notification.indicateurs">
					La vigilance <strong>{{ ind.indicateur | uppercase }}</strong>
					<ng-container *ngIf="ind.ancienNiveau && ind.ancienNiveau.trim() && ind.ancienNiveau !== ind.nouveauNiveau; else sansAncienNiveau">
						est dégradée du niveau
						<strong [ngClass]="niveauClass(ind.ancienNiveau)">{{ ind.ancienNiveau | uppercase }}</strong>
						au niveau
						<strong [ngClass]="niveauClass(ind.nouveauNiveau)">{{ ind.nouveauNiveau | uppercase }}</strong>
					</ng-container>
					<ng-template #sansAncienNiveau>
						est au niveau
						<strong [ngClass]="niveauClass(ind.nouveauNiveau)">{{ ind.nouveauNiveau | uppercase }}</strong>
					</ng-template>
					<span *ngIf="ind.regle" class="notif-meteo-regle"> ({{ ind.regle }})</span>
				</li>
			</ul>
			
			<p class="notif-meteo-acces" *ngIf="notification.accesNumeros?.length">
				Accès concernés : <strong>{{ notification.accesNumeros.join(', ') }}</strong>
			</p>

			<span class="datemaj">Mise à jour du {{ notification.dateReception | localDateTimeToDate: true | date : 'dd/MM/yyyy à HH:mm' }}</span>
		</div>

		<div class="form-group text-center">
			<button type="button" class="btn btn-default btn-lg"
				(click)="masquer(notification)">Ok</button>
		</div>
	</div>

</div>